import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const PrefsCtx = createContext(null);

const LOCAL_KEY = "sd_prefs";

function readLocal() {
  try { return JSON.parse(localStorage.getItem(LOCAL_KEY) || "{}"); } catch { return {}; }
}

function writeLocal(p) {
  try { localStorage.setItem(LOCAL_KEY, JSON.stringify(p)); } catch (_) {}
}

export function PrefsProvider({ children }) {
  const { user } = useAuth();
  const [prefs, setPrefs] = useState(() => {
    const local = readLocal();
    return { font_size: local.font_size || "normal", dark_mode: !!local.dark_mode };
  });

  // hydrate from server when a user is present
  useEffect(() => {
    if (!user) return;
    if (user.preferences) setPrefs(user.preferences);
  }, [user]);

  // apply to <html> class for dark mode + font size
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", !!prefs.dark_mode);
    root.classList.toggle("font-large", prefs.font_size === "large");
    writeLocal(prefs);
  }, [prefs]);

  const update = useCallback(async (patch) => {
    setPrefs((p) => ({ ...p, ...patch }));
    if (user) {
      try { await api.put("/preferences", patch); } catch (_) {}
    }
  }, [user]);

  return <PrefsCtx.Provider value={{ prefs, update }}>{children}</PrefsCtx.Provider>;
}

export const usePrefs = () => useContext(PrefsCtx);
